module.exports = __webpack_public_path__ + "img/BR.92fc6153.svg";